function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 7V11.5",
  stroke: "#E95164",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 16C11.6213 16 12.125 15.4963 12.125 14.875C12.125 14.2537 11.6213 13.75 11 13.75C10.3787 13.75 9.875 14.2537 9.875 14.875C9.875 15.4963 10.3787 16 11 16Z",
  fill: "#E95164"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.70176 1.74857L1.45399 15.9978C1.32201 16.2258 1.25242 16.4846 1.2522 16.748C1.25198 17.0115 1.32115 17.2703 1.45275 17.4986C1.58434 17.7268 1.77373 17.9163 2.00184 18.0481C2.22996 18.1799 2.48876 18.2493 2.7522 18.2493H19.2477C19.5112 18.2493 19.77 18.1799 19.9981 18.0481C20.2262 17.9163 20.4156 17.7268 20.5472 17.4986C20.6788 17.2703 20.748 17.0115 20.7478 16.748C20.7475 16.4846 20.6779 16.2258 20.546 15.9978L12.2982 1.74857C12.1664 1.52093 11.9771 1.33193 11.7493 1.20055C11.5214 1.06916 11.263 1 11 1C10.7369 1 10.4785 1.06916 10.2507 1.20055C10.0228 1.33193 9.83353 1.52093 9.70176 1.74857V1.74857Z",
  stroke: "#E95164",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ca2196e8.svg";
export { ForwardRef as ReactComponent };